// New-conversation nudge (ipa-training-mode).
// Cross-repo Nudge Contract v1 (LOCKED with the orchestrator team):
//   SSE event: `event: nudge`, data = { nudge_id, nudge_type, reason, message }
//   Ack: POST { nudge_id, nudge_type, action, conversation_id } to NUDGE_ACK_PATH
// Only training mode renders the banner; the SSE handler always parses the
// event so a stray nudge outside training mode is simply dropped (fail-safe).
// SSE event name dispatched by the orchestrator chat stream.
export const NUDGE_SSE_EVENT = 'nudge';
// Orchestrator ack endpoint (relative to orchestratorApiClient's baseURL).
// Reconciled to the orchestrator's actual route (routes/nudges.py → POST
// /nudges/ack) — acks apply to nudge types beyond the coach, so the resource
// is nested under /nudges, not /coach.
export const NUDGE_ACK_PATH = '/nudges/ack';
// nudge_type values (contract v1 defines exactly one; kept as a union type +
// const for forward-compatible extension without magic strings).
export const NUDGE_TYPE_NEW_CONVERSATION = 'new_conversation';
// Ack action values.
export const NUDGE_ACTION_ACCEPTED = 'accepted';
export const NUDGE_ACTION_DISMISSED = 'dismissed';
